import React from 'react';
import { Modal } from 'react-bootstrap';

const ConfirmationModal = ({ 
  show, 
  handleClose, 
  handleConfirm, 
  title, 
  message, 
  confirmText = "Confirm", 
  cancelText = "Cancel",
  variant = "primary", // primary, danger, warning, success
  icon = "fas fa-exclamation-circle"
}) => {
  const getVariantColor = () => {
    switch (variant) {
      case 'danger': return '#dc3545';
      case 'warning': return '#ffc107';
      case 'success': return '#10b981';
      case 'emerald': return '#059669';
      default: return '#004d2c';
    }
  };

  const color = getVariantColor();

  return (
    <Modal show={show} onHide={handleClose} centered size="md" className="confirmation-modal">
      <div style={{ padding: '30px', textAlign: 'center' }}>
        <div style={{ 
          width: '70px', 
          height: '70px', 
          borderRadius: '50%', 
          backgroundColor: `${color}15`, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          margin: '0 auto 20px',
          border: `2px solid ${color}30`
        }}>
          <i className={icon} style={{ fontSize: '30px', color: color }}></i>
        </div>
        
        <h3 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '15px', color: '#333' }}>
          {title}
        </h3>
        
        <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6', marginBottom: '25px' }}>
          {message}
        </p>
        
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
          <button
            onClick={handleClose}
            style={{ 
              padding: '10px 25px', 
              borderRadius: '8px', 
              border: '1px solid #ddd', 
              backgroundColor: '#fff', 
              color: '#666',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            style={{ 
              padding: '10px 25px', 
              borderRadius: '8px', 
              border: 'none', 
              backgroundColor: color, 
              color: '#fff',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: `0 4px 10px ${color}40`
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
